import { atom } from 'jotai';
import { NnSundVaegtProgramDto } from '@/shared/interfaces/api/sundvaegt-interfaces';
import { formatNumber } from '@/shared/helpers/formatNumber';
import { createWeightLogCards } from '../../sundvaegt/lib/helpers';
import { fetchNnSundvaegtProgramAtom } from './fetchNnSundvaegtProgramAtom';
import {
    WeightLogCardType,
    WeightLogsUI,
} from '@/features/programs/widgets/sundvaegt/model/types';

export const weightLogsAtom = atom<WeightLogsUI | null>((get) => {
    const program: NnSundVaegtProgramDto = get(
        fetchNnSundvaegtProgramAtom,
    ).data;
    if (!program || program.WeightLogs.length < 1) return null;

    const sortedLogs = [...program.WeightLogs].sort(
        (a, b) => new Date(b.Date).getTime() - new Date(a.Date).getTime(),
    );

    const initialWeight = sortedLogs[0].WeightKg;
    const formattedTotalWeightLossGoal = program.DesiredWeightKg
        ? `${formatNumber(initialWeight - program.DesiredWeightKg)} kg`
        : undefined;

    const cards: WeightLogCardType[] = createWeightLogCards(
        sortedLogs,
        initialWeight,
        formattedTotalWeightLossGoal,
    );

    return { cards };
});
